/**
 * Eaze WhatsApp FAB positions .gty-wacb-wrapper inside open shadow DOM,
 * so theme CSS cannot move it. Lift it clear of sticky / inline ATC.
 */
(function () {
  var DEFAULT_BOTTOM = '16px';
  var STICKY_BOTTOM = '90px';
  var styleEl = null;
  var lastBottom = '';

  function findHost() {
    return document.querySelector('gty-whatsapp-chat-button');
  }

  function findWrapper() {
    var host = findHost();
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('.gty-wacb-wrapper');
  }

  function ensureStyle(shadowRoot) {
    if (styleEl && styleEl.isConnected) return styleEl;
    styleEl = shadowRoot.getElementById('aur-wa-lift');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'aur-wa-lift';
      shadowRoot.appendChild(styleEl);
    }
    return styleEl;
  }

  function stickyOn() {
    return (
      document.body.classList.contains('aur-sticky-atc-on') ||
      !!document.querySelector('.sticky-atc.is-visible')
    );
  }

  function bottomForInlineAtc() {
    var btn = document.querySelector(
      '.sticky-atc.is-visible .button, button[name="add"], .product-form__submit'
    );
    if (!btn || stickyOn()) return null;

    var r = btn.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    if (!vh || r.height < 1) return null;

    /* FAB zone ~ bottom 16 + 64 height */
    var fabTop = vh - 16 - 64;
    var fabBottom = vh - 16;
    var overlaps =
      r.bottom > fabTop && r.top < fabBottom && r.right > (window.innerWidth || 0) - 90;

    if (!overlaps) return null;

    /* Sit just above the ATC button */
    var lift = Math.ceil(vh - r.top + 12);
    lift = Math.max(90, Math.min(lift, 220));
    return lift + 'px';
  }

  function desiredBottom() {
    if (stickyOn()) return STICKY_BOTTOM;
    return bottomForInlineAtc() || DEFAULT_BOTTOM;
  }

  function apply() {
    var wrapper = findWrapper();
    if (!wrapper) return false;
    var root = wrapper.getRootNode();
    if (!root || !root.host) return false;

    var bottom = desiredBottom();
    if (bottom === lastBottom && styleEl && styleEl.isConnected) return true;

    ensureStyle(root);
    styleEl.textContent = '.gty-wacb-wrapper{bottom:' + bottom + '!important}';
    lastBottom = bottom;
    return true;
  }

  function tick() {
    if (!apply()) return;
  }

  var tries = 0;
  var boot = setInterval(function () {
    tries += 1;
    if (apply() || tries > 40) clearInterval(boot);
  }, 250);

  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);
  document.addEventListener('aur:sticky-atc', tick);

  var mo = new MutationObserver(tick);
  mo.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });
})();
